import {
  Checkbox as MUICheckbox,
  FormControlLabel,
  CheckboxProps as MUICheckboxProps,
} from '@mui/material';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import { useCheckbox } from './useCheckbox';

export type LocalCheckboxProps = {
  id: string;
  displayLabel: React.ReactNode;
  displayLabelSize?: 'normal' | 'medium' | 'small';
  showBorderBox?: boolean;
  noHover?: boolean;
  onChange?: (id: string, checked: boolean) => void;
  width?: string | number;
  labelStyle?: React.CSSProperties;
  formControlLabelStyle?: React.CSSProperties;
};

export type CheckboxProps = LocalCheckboxProps & Omit<MUICheckboxProps, 'onChange'>;

export function Checkbox(props: CheckboxProps) {
  const {
    id,
    displayLabel,
    showBorderBox,
    noHover,
    width,
    onChangeHandler,
    labelStyle,
    formControlLabelStyle,
    ...rest
  } = useCheckbox(props);

  return (
    <FormControlLabel
      control={
        <MUICheckbox
          {...rest}
          onChange={onChangeHandler}
          sx={
            noHover
              ? { backgroundColor: 'transparent' }
              : { '&:hover': { borderRadius: `${borderRadius.sm}px` } }
          }
        />
      }
      label={displayLabel}
      slotProps={{
        typography: {
          sx: labelStyle,
        },
      }}
      sx={{
        ...formControlLabelStyle,
        ...(showBorderBox && {
          // TODO: no VDS token for this value — needs designer input (#252a36)
          border: '1px solid #252a36',
          borderRadius: `${borderRadius.sm}px`,
          padding: '7px 4px',
          backgroundColor: 'background.paper',
        }),
        width: width || 'auto', // Apply the width style
      }}
    />
  );
}

export default Checkbox;
